import styled from 'styled-components';

export const Wrapper = styled.div`
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  padding: 16px 0 16px 16px;

  a {
    display: flex;
    width: 100%;
    color: #333f48;
    &:hover,
    &:active {
      color: #2b6ed2;
    }
  }
`;
